/**
 * Folder-tree shaping + body preview for the shared template picker. Generic over
 * the app's template row so `apps/hub` can pass its richer `EmailTemplate` and get
 * the same type back out of the tree.
 */
/** The folder a template belongs to, tolerating either the hydrated relation or the raw column. */
function templateFolderId(template) {
    return template.folder?.id ?? template.folder_id ?? null;
}
export function buildFolderTree(folders, templates) {
    const folderMap = new Map();
    folders.forEach((folder) => {
        folderMap.set(folder.id, {
            ...folder,
            children: [],
            templates: templates.filter((t) => templateFolderId(t) === folder.id),
        });
    });
    const rootFolders = [];
    folders.forEach((folder) => {
        const folderWithChildren = folderMap.get(folder.id);
        if (folder.parent_id) {
            const parent = folderMap.get(folder.parent_id);
            if (parent) {
                parent.children.push(folderWithChildren);
            }
        }
        else {
            rootFolders.push(folderWithChildren);
        }
    });
    return rootFolders;
}
export function hasTemplatesRecursive(folder) {
    return (folder.templates.length > 0 || folder.children.some((child) => hasTemplatesRecursive(child)));
}
/** Templates with no folder — the picker's root list. */
export function rootTemplatesOf(templates) {
    return templates.filter((t) => templateFolderId(t) === null);
}
export function getTemplateBodyPreview(html, maxLength = 180) {
    if (!html)
        return "";
    const plainText = html
        .replace(/<style[\s\S]*?<\/style>/gi, " ")
        .replace(/<script[\s\S]*?<\/script>/gi, " ")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&amp;/gi, "&")
        .replace(/&lt;/gi, "<")
        .replace(/&gt;/gi, ">")
        .replace(/&quot;/gi, String.fromCharCode(34))
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, " ")
        .trim();
    if (plainText.length <= maxLength)
        return plainText;
    return `${plainText.slice(0, maxLength).trimEnd()}...`;
}
